module.exports = __webpack_public_path__ + "img/mind_skeleton_1.d445673a.png";